module.exports = __webpack_public_path__ + "assets/img/2b24de580293ac79e0489d5966f3b9e7.png";